import * as React from 'react'

import { Card } from '../../../../app/features/common/Card'
import { FooterWithButtons } from '../../components/FooterWithButtons'

import { DriverWithId } from '@/app/types/creator'

import ViolationsGrupedTable from './ViolationGrupedTable'

type Props = {
  onNext: () => void
  onPrev: () => void
  drivers: DriverWithId[]
  companyId: string
}
export const ViolationsStep = ({
  onNext,
  onPrev,
  drivers,
  companyId,
}: Props) => {
  return (
    <Card
      className="tw-inline-block tw-h-full tw-max-w-full tw-bg-base-100 tw-pb-3 tw-pt-0"
      classNameContent="!tw-px-0 !tw-pt-0 tw-flex tw-flex-col tw-h-full"
      paddingTop={false}
    >
      <ViolationsGrupedTable companyId={companyId} drivers={drivers} />
        <FooterWithButtons
          onNext={onNext}
          onPrev={onPrev}
          className="tw-border-t tw-border-base-300"
        />
    </Card>
  )
}
